require("utility/progress_bar");

class ProgressBar extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	getMessage(index) {
		if (this.props.message) {
			return (<div className="progressMessage">
						{ this.props.message }
					</div>)
		}
		if (this.props.messages && this.props.messages.length > index) {
			return (<div className="progressMessage">
						{ this.props.messages[index] }
					</div>)
		}
		return null
	}
	render() {
		var progress;
		if (this.props.progress) {
			progress = this.props.progress; 
		} else {
			progress = this.props.current / this.props.total; 
		}
		progress = Math.min((progress || 0.0), 1.0);

		var percent = Math.round(progress * 100);
		var total = this.props.total;

		var barClassName = "progress-bar";
		
		// Red, Orange, Green thresholds if provided 
		if (this.props.colorThreshold) {
			var first_threshold = this.props.colorThreshold[0] / this.props.total;
			var second_threshold = this.props.colorThreshold[1] / this.props.total;
		} else {
			var first_threshold = 0.30;
			var second_threshold = 1.0;
		}
		if (this.props.dynamicColor) {
			if (progress < first_threshold) {
				barClassName += " progress-bar-danger";
				var messageIndex = 0
			} else if (progress < second_threshold) {
				barClassName += " progress-bar-warning";
				var messageIndex = 1
			} else {
				barClassName += " progress-bar-success";
				var messageIndex = 2
			}
		} else if (this.props.className == null) {
			barClassName += " progress-bar-success";
		}
		if (this.props.className) {
			barClassName += " " + this.props.className;
		}
		var message = this.getMessage(messageIndex)
		return (<div className="ProgressBar">
					<div className="progress">
						<div className={barClassName} role="progressbar" aria-valuenow={percent} aria-valuemin="0" aria-valuemax="100"
							style={{width: (percent + "%"), minWidth: 0}}>
						</div>
					</div>
					{ message }
				</div>
			)
	}
};

ProgressBar.propTypes = StrictPropTypes({
	current: PropTypes.number,
	total: PropTypes.number,
	dynamicColor: PropTypes.bool,
	colorThreshold: PropTypes.array,
	messages: PropTypes.array,
	message: PropTypes.string,
	className: PropTypes.string
});

module.exports = ProgressBar;



// WEBPACK FOOTER //
// ./modules/components/utility/ProgressBar.js